<div class="search-filter-section">
  <app-searchbar
    placeholder="Search by customer, plate or subscription ID."
    [(searchTerm)]="searchTerm"
    (searchChange)="onSearchChange($event)"
    iconSize="small"
  >
  </app-searchbar>

  <div class="filter-container">
    <app-action-button
      buttonText="Filter"
      iconSrc="assets/images/package/adjustments.svg"
      [showCount]="activeFilterCount > 0"
      [count]="activeFilterCount"
      (buttonClick)="onFilter()"
    >
    </app-action-button>
  </div>
</div>

<div class="pause-events-state" *ngIf="loading">Loading pause events…</div>
<div class="pause-events-state pause-events-state--error" *ngIf="!loading && errorMessage">
  {{ errorMessage }}
</div>
<div class="pause-events-state" *ngIf="!loading && !errorMessage && rows.length === 0">
  No pause events found.
</div>

<div class="pause-events-table-wrap" *ngIf="!loading && rows.length > 0">
  <table class="pause-events-table">
    <thead>
      <tr>
        <th>Timestamp</th>
        <th>Customer/Plate</th>
        <th>Plan</th>
        <th>Action</th>
        <th>Pause window</th>
        <th>Performed by</th>
        <th>SMS</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of rows">
        <tr>
          <td>{{ row.timestamp }}</td>
          <td>
            <div class="pause-events-stack">
              <span *ngIf="row.customerName">{{ row.customerName }}</span>
              <span *ngIf="row.licensePlate">{{ row.licensePlate }}</span>
            </div>
          </td>
          <td>{{ row.planName }}</td>
          <td>
            <span class="pause-events-pill" [ngClass]="'pause-events-pill--' + row.actionVariant">
              {{ row.actionLabel }}
            </span>
          </td>
          <td>
            <div class="pause-events-stack">
              <span *ngFor="let line of row.pauseWindowLines">{{ line }}</span>
            </div>
          </td>
          <td>{{ row.performedBy }}</td>
          <td>
            <div class="pause-events-stack">
              <span
                *ngIf="row.sms.variant; else smsNotApplicable"
                class="pause-events-pill"
                [ngClass]="'pause-events-pill--' + row.sms.variant"
              >
                {{ row.sms.label }}
              </span>
              <ng-template #smsNotApplicable>{{ row.sms.label }}</ng-template>
              <span class="pause-events-muted" *ngIf="row.sms.detail">{{ row.sms.detail }}</span>
            </div>
          </td>
          <td>
            <button type="button" class="btn btn-outlined btn-small" (click)="toggleExpanded(row)">
              {{ expandedRowId === row.id ? 'Hide' : 'Details' }}
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowId === row.id" class="pause-events-details-row">
          <td colspan="8">
            <dl class="pause-events-meta">
              <dt>Time zone</dt>
              <dd>{{ row.timeZone }}</dd>
              <dt>Subscription ID</dt>
              <dd>{{ row.subscriptionId }}</dd>
              <dt>SMS provider message ID</dt>
              <dd>{{ row.providerMessageId }}</dd>
            </dl>
            <pre class="pause-events-payload">{{ row.payload | json }}</pre>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<app-pagination-bar
  *ngIf="totalItems > 0"
  [paginationData]="paginationData"
  (pageChange)="onPageChange($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
>
</app-pagination-bar>

<!-- Filters -->
<app-filter-modal
  [isVisible]="showFilterModal"
  header="Filters"
  primaryButtonText="Apply Filters"
  secondaryButtonText="Clear Filters"
  [categories]="filterCategories"
  [customRangeConfig]="filterModalCustomRangeConfig"
  (close)="onCloseFilterModal()"
  (apply)="onApplyFilters($event)"
  (customRangeChange)="onCustomRangeChange($event)"
  (optionChange)="onFilterOptionChange($event)"
>
</app-filter-modal>
